import { render, staticRenderFns } from "./Districts.vue?vue&type=template&id=4b4e53a1&scoped=true&lang=pug&"
import script from "./Districts.vue?vue&type=script&lang=ts&"
export * from "./Districts.vue?vue&type=script&lang=ts&"
import style0 from "./Districts.vue?vue&type=style&index=0&id=4b4e53a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4e53a1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VList,VListItem,VListItemAction,VListItemTitle,VRow})
